import { NavLink } from "react-router-dom";
import { isString } from "../utils";
import "./NavBar.css";
import { useCurrentDevice } from "../hooks";
import clsx from "clsx";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface NavBarProps {
  items: {
    labelOrIcon: string | IconDefinition;
    linkOrOnClick: (() => void) | string;
  }[];
  showNavbar: boolean;
}

const NavBar: React.FC<NavBarProps> = ({ showNavbar, items }) => {
  const { isPhone } = useCurrentDevice();
  return (
    <nav
      className={clsx([
        "navbar bg-gray-300 flex px-4",
        {
          show: showNavbar,
          hide: !showNavbar,
          "gap-1 justify-between text-sm": isPhone,
          "gap-8 justify-start": !isPhone,
        },
      ])}
    >
      {items.map((item, itemIndex) => {
        const labelOrIcon = isString(item.labelOrIcon) ? (
          item.labelOrIcon
        ) : (
          <FontAwesomeIcon icon={item.labelOrIcon} />
        );
        const linkOrButton = isString(item.linkOrOnClick) ? (
          <NavLink
            to={item.linkOrOnClick}
            className={({ isActive }) => clsx({ "text-purple-600": isActive })}
          >
            {labelOrIcon}
          </NavLink>
        ) : (
          <button onClick={item.linkOrOnClick}>{labelOrIcon}</button>
        );

        return (
          <div
            key={String(item.labelOrIcon)}
            className={clsx([
              "text-gray-800 hover:text-purple-600 font-bold flex flex-col justify-center",
              { "ml-auto": !isPhone && itemIndex === items.length - 1 },
            ])}
          >
            {linkOrButton}
          </div>
        );
      })}
    </nav>
  );
};

export default NavBar;
